<template>
    <div class="question-item" v-bind:class="{'is-read':question.flag}">
        <p>
            <input type="checkbox" v-on:change="markRead" />
            &nbsp;
            <b>{{question.question}}</b> asked by <!--<a v-bind:href="`https://twitch.tv/${question.user}/`">--> {{question.user}}<!--</a>-->
            <button @click="$emit('del-question', question.qid)" class="del">
                x
            </button>
        </p>
    </div>
</template>

<script>
    export default {
        name: "QuestionItem",
        props: ["question"],
        methods: {
            markRead() {
                this.$emit('del-question', this.question.qid);
                this.question.flag = !this.question.flag;
            }
        }
    }
</script>

<style scoped>
    .question-item {
        background: #f4f4f4;
        padding: 10px;
        border-bottom: 1px #ccc dotted;
    }

    .is-read {
        text-decoration: line-through;
    }

    .del {
        background: #ff0000;
        color: #fff;
        border: none;
        padding: 5px 9px;
        border-radius: 50%;
        cursor: pointer;
        float: right;
    }
</style>
